import { styled, Theme, Typography, WithTheme } from '@material-ui/core'
import { CSSProperties } from '@material-ui/core/styles/withStyles'

const BORDER_WIDTH = 2
const TITLE_WRAPPER_WIDTH = 200
const ACTION_INDICATOR_SIZE_BIG = 20
const ACTION_INDICATOR_SIZE = 16
const WRAPPER_SIZE = 56
const WRAPPER_WIDTH_EXPANDED = 225

interface WrapperProps extends WithTheme {
  isActive?: boolean
}

const wrapperStyles: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  borderRadius: 10,
  borderWidth: 2,
  borderColor: 'transparent',
  borderStyle: 'solid',
  boxSizing: 'border-box',
  height: WRAPPER_SIZE,
  position: 'relative',
  transitionDuration: '.3s',
  transitionProperty: 'color, background-color, border-color',
  cursor: 'pointer',
  '& svg': {
    fontSize: 30,
  },
}

export const Wrapper = styled('button')(
  ({ theme, isActive }: WrapperProps) => ({
    backgroundColor: 'transparent',
    justifyContent: 'center',
    width: WRAPPER_SIZE,
    color: theme.palette.common.white,
    '&:not(:last-child)': {
      marginBottom: theme.spacing(0.6),
    },
    ...wrapperStyles,
    ...(isActive
      ? {
          backgroundColor: theme.palette.common.white,
          color: theme.palette.primary.main,
        }
      : {
          '&:hover': {
            backgroundColor: 'transparent',
            borderColor: theme.palette.common.white,
          },
        }),
  })
)

export const WrapperExpanded = styled('button')(
  ({ theme, isActive }: WrapperProps) => ({
    backgroundColor: 'transparent',
    justifyContent: 'flex-start',
    width: WRAPPER_WIDTH_EXPANDED,
    '&:not(:last-child)': {
      marginBottom: theme.spacing(0.6),
    },
    ...wrapperStyles,
    ...(isActive
      ? {
          borderColor: theme.palette.primary.light,
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.primary.light,
        }
      : {
          '&:hover': {
            borderColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.light,
          },
        }),
  })
)

export const TitleWrapper = styled('div')(({ theme }) => ({
  width: TITLE_WRAPPER_WIDTH,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: theme.spacing(),
}))

export const IconWrapper = styled('i')(({ theme }) => ({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: WRAPPER_SIZE - BORDER_WIDTH * 2,
  height: '100%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const Title = styled(Typography)(
  ({ isExpanded, theme }: { theme: Theme; isExpanded: boolean }) => ({
    opacity: isExpanded ? 1 : 0,
    color: 'inherit',
    marginLeft: theme.spacing(4),
  })
)

const actionIndicatorStyles = {
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  transitionProperty: 'all',
  transitionTimingFunction: 'ease-in-out',
  transitionDuration: '0.2s',
  borderRadius: '50%',
}

export const ActionIndicator = styled('div')(
  ({ theme, hide = false }: { theme: Theme; hide?: boolean }) => ({
    ...actionIndicatorStyles,
    ...(hide
      ? {
          height: 0,
          width: 0,
          transitionDuration: '0s',
        }
      : {
          height: ACTION_INDICATOR_SIZE_BIG,
          width: ACTION_INDICATOR_SIZE_BIG,
        }),
    position: 'absolute',
    top: 3,
    left: 50,
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.error.main,
  })
)

export const ActionIndicatorExpanded = styled('div')(
  ({ theme }: { theme: Theme }) => ({
    height: ACTION_INDICATOR_SIZE,
    width: ACTION_INDICATOR_SIZE,
    backgroundColor: theme.palette.error.main,
    ...actionIndicatorStyles,
  })
)
